/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiNote } from './ApiNote';
import {
    ApiNoteFromJSON,
    ApiNoteFromJSONTyped,
    ApiNoteToJSON,
    ApiNoteToJSONTyped,
} from './ApiNote';

/**
 * 
 * @export
 * @interface ApiRelatedAlertBulkStatus
 */
export interface ApiRelatedAlertBulkStatus {
    /**
     * 
     * @type {ApiNote}
     * @memberof ApiRelatedAlertBulkStatus
     */
    note: ApiNote;
    /**
     * 
     * @type {string}
     * @memberof ApiRelatedAlertBulkStatus
     */
    fromStatus: string;
    /**
     * 
     * @type {string}
     * @memberof ApiRelatedAlertBulkStatus
     */
    toStatus: string;
}

/**
 * Check if a given object implements the ApiRelatedAlertBulkStatus interface.
 */
export function instanceOfApiRelatedAlertBulkStatus(value: object): value is ApiRelatedAlertBulkStatus {
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('fromStatus' in value) || value['fromStatus'] === undefined) return false;
    if (!('toStatus' in value) || value['toStatus'] === undefined) return false;
    return true;
}

export function ApiRelatedAlertBulkStatusFromJSON(json: any): ApiRelatedAlertBulkStatus {
    return ApiRelatedAlertBulkStatusFromJSONTyped(json, false);
}

export function ApiRelatedAlertBulkStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiRelatedAlertBulkStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'note': ApiNoteFromJSON(json['note']),
        'fromStatus': json['fromStatus'],
        'toStatus': json['toStatus'],
    };
}

export function ApiRelatedAlertBulkStatusToJSON(json: any): ApiRelatedAlertBulkStatus {
    return ApiRelatedAlertBulkStatusToJSONTyped(json, false);
}

export function ApiRelatedAlertBulkStatusToJSONTyped(value?: ApiRelatedAlertBulkStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': ApiNoteToJSON(value['note']),
        'fromStatus': value['fromStatus'],
        'toStatus': value['toStatus'],
    };
}

